import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css'
import './i18n.js'
import App from './App.jsx'
import { ThemeProvider } from './contexts/ThemeContext.jsx';

createRoot(document.getElementById('root')).render(
  <ThemeProvider>
    <Router>
      <App />
    </Router>
  </ThemeProvider>,
)
